import { Styles } from 'react-modal'
import theme from 'theme_'

import {
  StyledUniversalModalContent,
  StyledUniversalModalInner,
} from './styles'
import { ModalProps } from './types'

// Content styling in styles.ts; Overlay styling here
export const customModalStyles: Styles = {
  content: {
    padding: 0,
  },
  overlay: {
    zIndex: theme.zIndex.modal,
    backgroundColor: theme.overlay.modalCommon,
    backdropFilter: theme.overlay.SBlur,
    WebkitBackdropFilter: theme.overlay.SBlur,
  },
}

// On tablet acts like BaseModal and on mobile acts like BaseMobileModal
function BaseUniversalModal(props: ModalProps) {
  return (
    <StyledUniversalModalContent
      ariaHideApp={false}
      style={customModalStyles}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      onAfterOpen={() => (document.body.style.overflow = 'hidden')}
      onAfterClose={() => (document.body.style.overflow = 'unset')}
      {...props}
    >
      <StyledUniversalModalInner>{props.children}</StyledUniversalModalInner>
    </StyledUniversalModalContent>
  )
}

export default BaseUniversalModal
